import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-it-works-mem',
  templateUrl: './how-it-works-mem.component.html',
  styleUrls: ['./how-it-works-mem.component.scss']
})
export class HowItWorksMemComponent implements OnInit {

  @Input() section;
  stepsArr = [
    { number: 1, desc: 'Create your campaign in simple, easy steps, completely free of charge' },
    { number: 2, desc: 'Share the campaign using our easy-to-use tools' },
    { number: 3, desc: 'Receive online payments instantly' },

  ];
  constructor() { }

  ngOnInit() {
  }

}
